const openState = (item, m, forceOpenId) => {
  if (`${forceOpenId}` === `${m.id}`) {
    return true;
  }
  if (!item.id) {
    return false;
  } else {
    return item.level === 0 ? (m.code === item.code ? !m.open : false) : m.open;
  }
};

export const formatMenuState = (menus, item, forceOpenId) => {
  return [...menus].map((m) => ({
    ...m,
    choosed: m.id === item.id,
    open: openState(item, m, forceOpenId),
    children: (m.children ?? []).map((m) => ({
      ...m,
      choosed: m.id === item.id,
      children: (m.children ?? []).map((m) => ({
        ...m,
        choosed: m.id === item.id,
      })),
    })),
  }));
};
